import {Container} from './styles'
import { useState } from 'react'
import { api } from "../../services/api";
import { useHistory } from "react-router-dom";

import Input from '../../components/Input/InputSignUp'
import {alert} from '../../components/Alert'
import MaskInput from "../../components/Input/MaskInput";
import Button from "../../components/Button";

const PaymentCreditCard = () => {
    const history = useHistory();

    // Dados enviado para o pagar.me
    const [holder_name, setHolder_name] = useState('');
    const [number, setNumber] = useState('');
    const [exp_month, setExp_month] = useState('');
    const [exp_year, setExp_year] = useState('');
    const [cvv, setCvv] = useState('');

    // Dados enviados para api
    const payment_method ='credit_card';

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const response = await api.post("https://api.pagar.me/core/v5/tokens?appId=pk_test_DVBM2VmikrIOlZY7", {
                type: 'card',
                card: {
                    number,
                    holder_name,
                    exp_month,
                    exp_year,
                    cvv,
                }
            });
            if (response.data) {
                alert('Compra efetuada com sucesso.', 'success');
                history.push("/");
                // try {
                //     const pacotes = await api.post("packages/create", {
                //         package: {
                //             payment_method,
                //             card_hash: response.data.id,
                //         }
                //     });
                //     if (pacotes.data) {
                //         alert('Compra efetuada com sucesso.', 'success');
                //         history.push("/");
                //     }
                // } catch (error) {
                //     alert('Erro, tente novamente.','error');
                // }
            }
        } catch (error) {
            alert('Erro, tente novamente.','error');
        }
    }

    return(
    <Container>
        <h1>Quero adquirir meu pacote Vai de Férias</h1>
        <form onSubmit={handleSubmit} data-pagarmecheckout-form>
        <div className="form-1">
          <div className="sub-form-left">
            <h2>Preencha seus dados abaixo</h2>
          </div>
          <div className="sub-form"></div>
        </div>
            <div className="form-1">
                <div className="sub-form-left">
                <Input
                    placeholder ='Nome (como no Cartão)' 
                    value= {holder_name}
                    onChange ={(value) => setHolder_name(value.target.value)}
                    name="holder-name" 
                />
                </div>
                <div className="sub-form">
                <Input
                    placeholder='Número do Cartão'
                    value= {number}
                    onChange ={(value) => setNumber(value.target.value)}
                    name="card-number" 
                />
                <span data-pagarmecheckout-input="brand"></span>
                </div>
            </div>
            <div className="form-1">
                <div className="sub-form-left">
                <Input
                    placeholder='Mês de validade'
                    value= {exp_month}
                    onChange ={(value) => setExp_month(value.target.value)}
                    name="card-exp-month" 
                />
                </div>
                <div className="sub-form">
                <Input
                    placeholder='Ano de validade'
                    value= {exp_year}
                    onChange ={(value) => setExp_year(value.target.value)}
                    name="card-exp-year" 
                />
                </div>
            </div>
            <div className="form-1">
                <div className="sub-form-left">
                <Input
                    placeholder='CVV'
                    value={cvv}
                    onChange ={(value) => setCvv(value.target.value)}
                    name="cvv" 
                />
                </div>
            </div>
            <div className="div_button">
          <div className="button">
            <Button type="submit" format="home">Continuar</Button>
          </div>
        </div>
        </form>
    </Container>
    )
}



export default PaymentCreditCard